import { Component, type ErrorInfo, type ReactNode } from 'react';
import { COPY } from '@/shared/content/copy';
import { reportError } from '@/shared/lib/report-error';
import styles from './ls-error-boundary.module.scss';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Ловит ошибки отрисовки внутри виджета.
 *
 * Виджет встраивается на страницу партнёра: без этой границы любая ошибка
 * гасит не только модуль, но и выглядит как поломка их сайта.
 */
export class LsErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    reportError(error, info.componentStack ?? undefined);
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className={styles['ls-error-boundary']} role="alert">
        <p className={styles['ls-error-boundary__title']}>{COPY.error.title}</p>
        <p className={styles['ls-error-boundary__text']}>{COPY.error.text}</p>
        <button
          className={styles['ls-error-boundary__retry']}
          type="button"
          onClick={() => window.location.reload()}
        >
          {COPY.error.retry}
        </button>
      </div>
    );
  }
}
